export type OrgType =
  | 'wealth-management-firm'
  | 'insurance-agency'
  | 'broker-dealer'
  | 'bga-or-imo'
  | 'estate-planning-firm'
  | 'ccrc-or-ccah'
  | 'senior-living-or-home-care'
  | 'employee-benefits-firm'
  | 'other';

export type UserIntent = 'just-for-me' | 'small-team' | 'evaluating';

export type Role =
  | 'advisor-planner'
  | 'insurance-agent'
  | 'owner-principal'
  | 'paraplanner-associate'
  | 'operations-admin'
  | 'other';

export type LtcVolume = 'all-the-time' | 'occasionally' | 'rarely' | 'not-yet';

export type LtcInitiator = 'clients-bring-it-up' | 'even-mix' | 'i-bring-it-up';

export type SellsLtcInsurance =
  | 'yes-often'
  | 'yes-when-makes-sense'
  | 'partner-handles-it'
  | 'not-yet-want-to'
  | 'no-and-dont-want-to';

export type IsLicensed = 'yes' | 'not-yet-want-to-be' | 'no-and-dont-want-to-be';

export type BgaStatus = 'yes-great' | 'yes-but-move' | 'not-yet';

export type BgaPartnerInterest =
  | 'connect-with-partners'
  | 'explore-waterlily-bga'
  | 'all-set-for-now';

export interface QuestionnaireAnswers {
  user_intent?: UserIntent;
  role?: Role;
  ltc_volume?: LtcVolume;
  ltc_initiator?: LtcInitiator;
  sells_ltc_insurance?: SellsLtcInsurance;
  is_licensed?: IsLicensed;
  bga_status?: BgaStatus;
  current_bgas?: string;
  bga_partner_interest?: BgaPartnerInterest;
  tech_stack?: string[];
  tech_stack_other_text?: string;
  primary_goal?: string;
  primary_goal_other_text?: string;
  secondary_goals?: string[];
  secondary_goals_other_text?: string;
  ltc_challenges?: string[];
  ltc_challenges_other_text?: string;
  process_description?: string;
}

export type QuestionId = keyof QuestionnaireAnswers;

export interface AnswerOption<TValue extends string = string> {
  value: TValue;
  label: string;
}

export const ORG_TYPE_OPTIONS: AnswerOption<OrgType>[] = [
  { value: 'wealth-management-firm', label: 'Wealth Management Firm' },
  { value: 'insurance-agency', label: 'Insurance Agency' },
  { value: 'broker-dealer', label: 'Broker Dealer' },
  { value: 'bga-or-imo', label: 'BGA or IMO' },
  { value: 'estate-planning-firm', label: 'Estate Planning Firm' },
  { value: 'ccrc-or-ccah', label: 'CCRC or CCAH' },
  {
    value: 'senior-living-or-home-care',
    label: 'Senior Living Facility or Home Care Services',
  },
  { value: 'employee-benefits-firm', label: 'Employee Benefits Firm' },
  { value: 'other', label: 'Other' },
];

export const ORG_TYPE_LABEL: Record<OrgType, string> = ORG_TYPE_OPTIONS.reduce(
  (acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
  },
  {} as Record<OrgType, string>,
);
